<template>
	<div id="consignments" class="consignments">
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromConsignments" @change="getAllConsignmentsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToConsignments" @change="getAllConsignmentsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchConsignments"
					v-model="searchConsignments"
					v-on:keyup.enter="getAllConsignmentsLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllConsignmentsLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nueva Campaña" @click="showConsignmentModalComponentLocal(0)">
					<i class="fas fa-plus"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsConsignment" @change="changeQRowsConsignment">
					<option>5</option>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>

		<div>
			<table class="table table-sm table-hover table-12">
				<thead>
					<tr>
						<th class="text-center">ID</th>
						<th class="text-center">Descripción</th>
						<th class="text-center">Campaña</th>
						<th class="text-center">Total</th>
						<th class="text-center">Estado</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in listConsignments" :key="index">
						<td class="text-center">{{ item.id }}</td>
						<td class="text-left">{{ item.description }}</td>
						<td class="text-left">{{ item.team.name }}</td>
						<td class="text-right">{{ methodFormatNumber(sumConsignmentPayment(item.payments)) }}</td>
						<td class="text-center">
							{{ (item.status === null) ? '-' : item.status.name }}
						</td>
						<td class="text-right">
							<i class="fas fa-exclamation-triangle text-warning margin-right5" v-show="analizePaymentsRejectedLocal(item.payments) > 0" :title="'Tiene ' + analizePaymentsRejectedLocal(item.payments) + ' pago(s) rechazado(s)'"></i>
							<i class="pointer far fa-eye text-info" @click="showConsignmentModalComponentLocal(item.id)"></i>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination :pagination="paginationConsignments" @getAllList="getAllConsignmentsLocal"></pagination>
		</div>

		<!-- Modal -->
		<button data-toggle="modal" data-target="#consignmentModal" ref="btnConsignmentModal"></button>
		<div class="modal fade" id="consignmentModal" tabindex="-1" aria-labelledby="consignmentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="consignmentModalLabel" v-if="objectConsignment.exists == 0">Remesa</h5>
						<h5 class="modal-title" id="consignmentModalLabel" v-else>Remesa Nº {{objectConsignment.id}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="border border-info container" style="padding-top:10px; padding-bottom:10px;">
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputDescription">Descripción</label>
										<input type="text" id="inputDescription" class="form-control form-control-sm" v-model='objectConsignment.description' placeholder="Nombre">
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputTeam">Campaña</label>
										<select id="inputTeam" class="form-control form-control-sm" v-model="objectConsignment.team_id">
											<option v-for="(item, index) in listTeams" :key="index" :value="item.id">{{ item.name }}</option>
										</select>
									</div>
								</div>
							</div>
							<div class="text-right">
								<button type="button" class="btn btn-sm btn-primary" @click="saveConsignmentLocal">Guardar</button>
							</div>
						</div>
						<hr>
						<payment-modal-component v-show="objectConsignment.exists > 0" ref="paymentModalComponent" controller="consignment"
								:id="id" title="Remesa"
								:modal="false"
								@addRow="addRowPayment"
								@removeRow="removeRowPayment"
								@uploadDocument="showUploadDocumentModalComponentLocal">
						</payment-modal-component>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		<upload-document-modal-component ref="uploadDocumentModalComponent" controller="payment" configUploadDocumentId="2" :id="paymentId" :btnDelete="true" :btnUpload="true"></upload-document-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import consignments from '@/mixins/consignments'
import team from '@/mixins/teams'
import payment from '@/mixins/generals/payment.js'

import Pagination from '@/components/Pagination.vue'
import PaymentModalComponent from '@/components/PaymentModalComponent.vue'
import UploadDocumentModalComponent from '@/components/UploadDocumentModalComponent.vue'

export default {
	name: 'Consignments',
	mixins: [axiosAction, errors, mixin, consignments, team, payment],
	data() {
		return {
			id: 0,
			paymentId: 0
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Remesas')
			this.setSubTitleModule('')
			this.setConsignmentInit()
		},
		addRowPayment(id, data) {
			this.addListConsignmentsPayment(id, data)
		},
		changeQRowsConsignmentLocal() {
			this.getAllConsignmentsLocal(1)
		},
		getAllConsignmentsLocal(page) {
			this.getAllConsignmentsByUserClient(page)
		},
		getAllConsignmentsResultLocal(response) {
		},
		getAllTeamsResultLocal(response) {
			if(this.listTeams.lengh == 0) {
				alert('No tienes campañas asignadas a uno de tus clientes')
			}
		},
		removeRowPayment(id, data) {
			this.deleteItemListConsignmentPayment(id, data)
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllConsignmentsResult': this.getAllConsignmentsResult(response); break;
				case 'getAllTeamsResult': this.getAllTeamsResult(response); break;
				case 'saveConsignmentResult': this.saveConsignmentResult(response); break;
				case 'showConsignmentResult': this.showConsignmentResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveConsignmentLocal() {
			this.saveConsignment()
		},
		saveConsignmentResultLocal(response) {
			if(response.data.success ==  true) {
				this.id = response.data.data.id
			}
		},
		setConsignmentInitLocal() {
			this.getAllTeamByUserClient(1, 42)
			this.getAllConsignmentsLocal(1)
		},
		showConsignmentModalComponentLocal(id) {
			this.id = id
			if(this.id == 0) {
				this.clearObjectConsignment()
				this.$refs.btnConsignmentModal.click()
			} else if(this.id > 0) {
				this.showConsignment(this.id)
			}
		},
		showConsignmentResultLocal(response) {
			if(response.data.success == true) {
				this.$refs.btnConsignmentModal.click()
			}
		},
		showPaymentModalComponentLocal(id) {
			this.id = id
			setTimeout(() => {
				this.$refs.paymentModalComponent.$refs.showPayment.click()
				this.$refs.paymentModalComponent.$refs.btnGetPayment.click()
			}, 10)
		},
		showUploadDocumentModalComponentLocal(id, idPayment) {
			this.paymentId = id
			setTimeout(() => {
				this.$refs.uploadDocumentModalComponent.$refs.btnGetUploadDocument.click()
				this.$refs.uploadDocumentModalComponent.$refs.showUploadDocument.click()
			}, 10)
		}
	},
	components: {
		'pagination': Pagination,
		'payment-modal-component': PaymentModalComponent,
		'upload-document-modal-component': UploadDocumentModalComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>